/**
 * The six-digit TOTP code, as a value the field can hold.
 *
 * Its own module rather than a second export beside `MfaChallengeScreen`,
 * because `react-refresh/only-export-components` is right about the cost: a
 * file that exports both a component and a helper loses fast refresh, and the
 * helper is shared by the sign-in challenge and the enrolment confirmation
 * anyway.
 */

/** RFC 6238 with `digits=6`, which is what `TotpSecret::uri()` advertises. */
export const CODE_LENGTH = 6;

/**
 * Drop everything that cannot be part of a code, and stop at six.
 *
 * NOT VALIDATION, and the difference matters. Authenticators display the code
 * as "123 456", so a paste carries a space; a field that rejected it would turn
 * a correct paste into a spent attempt, and attempts are budgeted five to a
 * challenge with one of the account's login attempts charged alongside. This
 * accepts what the user actually has and submits what the API actually wants.
 */
export function digitsOnly(raw: string): string {
  return raw.replace(/\D/g, '').slice(0, CODE_LENGTH);
}
